import { render, staticRenderFns } from "./StudentEligibilityNotice.vue?vue&type=template&id=48c715d1&scoped=true&"
var script = {}
import style0 from "./StudentEligibilityNotice.vue?vue&type=style&index=0&id=48c715d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c715d1",
  null
  
)

export default component.exports